import { CiCircleCheck, CiUser, CiWifiOn } from 'react-icons/ci'
import { BsSuitcase2 } from 'react-icons/bs'

import car from '../../assets/images/card-card.webp'
import { FleetModel } from '../../models/fleet.model'
import { capitalizeFirstLetter } from '../../utils/strings.util'
import Button from '../Button/Button'
import { ImageWithFallback } from '../Image/ImageWithFallback'
import style from './ResultCard.module.scss'
import { useEffect, useState } from 'react'

interface CarAdditionalCheckpoint {
  title: string
  condition?: (data: FleetModel) => boolean
}

const carAdditionalCheckpoints: CarAdditionalCheckpoint[] = [
  {
    title: 'First class chauffeur',
    condition: (data: FleetModel) => !data.type?.toLowerCase()?.includes('economy'),
  },
  { title: 'Free 60min airport parking' },
  { title: 'Free 60 mins waiting time for airport after landing, 15mins for all others' },
  { title: 'Meet and Greet' },
  { title: 'Complimentary water bottles' },
]

interface ResultCardProps {
  data: FleetModel
  goToCheckout: () => void
}

const ResultCard = ({ data, goToCheckout }: ResultCardProps) => {
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      const isLargeScreen = window.innerWidth >= 768 // tablet and above
      setIsTablet(isLargeScreen)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  return (
    <div className={style.resultCard} onClick={goToCheckout}>
      <div>
        <h4 className={style.resultCard__title}>{capitalizeFirstLetter(data.type)}</h4>
        <div className={style.resultCard__infoText}>{capitalizeFirstLetter(data.vehicleName)}</div>

        {/* Amenities */}
        {!isTablet && (
          <div className={style.resultCard__amenities}>
            {/* No of passengers */}
            <div className={`${style.resultCard__infoText} flex`}>
              <div className={style.carInfoItem}>
                <div className={style.carInfoItem__icon}>
                  <CiUser size={20} />
                </div>
                <span>{data.sittingCapacity} Passengers</span>
              </div>
            </div>

            {/* Luggage capacity */}
            <div className={`${style.resultCard__infoText} flex`}>
              <div className={style.carInfoItem}>
                <div className={style.carInfoItem__icon}>
                  <BsSuitcase2 size={20} />
                </div>
                <span>{data.luggageCapacity} Luggage</span>
              </div>
            </div>

            {/* On-board Wifi */}
            <div className={`${style.resultCard__infoText} flex`}>
              <div className={style.carInfoItem}>
                <div className={style.carInfoItem__icon}>
                  <CiWifiOn size={20} />
                </div>
                <span>On-board Wifi</span>
              </div>
            </div>
          </div>
        )}

        <picture className="flex-wrap align-center justify-center">
          <ImageWithFallback src={data.image ? data.image : car} alt="car" fallbackUrl={car} />
        </picture>
      </div>

      <aside>
        <div className={`${style.resultCard__content} flex-wrap justify-between`}>
          <div className={`${style.resultCard__about} flex-wrap`}>
            <div className={style.resultCard__info}>
              {/* Amenities */}
              {isTablet && (
                <div className={style.resultCard__amenities}>
                  {/* No of passengers */}
                  <div className={`${style.resultCard__infoText} flex`}>
                    <div className={style.carInfoItem}>
                      <div className={style.carInfoItem__icon}>
                        <CiUser size={20} />
                      </div>
                      <span>{data.sittingCapacity} passengers</span>
                    </div>
                  </div>

                  {/* Luggage capacity */}
                  <div className={`${style.resultCard__infoText} flex`}>
                    <div className={style.carInfoItem}>
                      <div className={style.carInfoItem__icon}>
                        <BsSuitcase2 size={20} />
                      </div>
                      <span>{data.luggageCapacity} luggage</span>
                    </div>
                  </div>

                  {/* On-board Wifi */}
                  <div className={`${style.resultCard__infoText} flex`}>
                    <div className={style.carInfoItem}>
                      <div className={style.carInfoItem__icon}>
                        <CiWifiOn size={20} />
                      </div>
                      <span>On-board Wifi</span>
                    </div>
                  </div>
                </div>
              )}

              {/*  Car additional checkpoints */}
              {carAdditionalCheckpoints
                .filter(item => (item.condition ? item.condition(data) : true))
                .map(item => (
                  <div key={item.title} className={`${style.resultCard__infoText} flex`}>
                    <div className={style.carInfoItem}>
                      <div className={style.carInfoItem__icon}>
                        <CiCircleCheck size={20} />
                      </div>
                      <span>{item.title}</span>
                    </div>
                  </div>
                ))}

              {/* Transmission type */}
              {/* <div className={`${style.resultCard__infoText} flex`}>
                <div className={style.carInfoItem}>
                  <img src={routeIcon} alt="route icon" />
                  <span>{data.transmissionType}</span>
                </div>
              </div> */}

              {/* Pick-up Shuttle to counter and car */}
              {/* <div className={`${style.resultCard__infoText} flex`}>
                <div className={style.carInfoItem}>
                  <img src={flightcon} alt="Flight" />
                  <span>Pick-up Shuttle to counter and car</span>
                </div>
              </div> */}
            </div>

            {/* Pay at pick-up and ratings */}
            {/* <div className={style.resultCard__info}>
              <div className={style.resultCard__infoText}>
                <p className={style.isGreen}>Pay at pick-up</p>
              </div>
              <div className={`${style.resultCard__infoText} ${style.isRating}`}>
                <div className={style.carInfoItem}>
                  <img src={likeThumbIcon} alt="Rating" width={8} height={8} />
                  <span>93% positive ratings</span>
                </div>
              </div>
              <div className={`${style.resultCard__infoText} flex`}>
                <div className={style.carInfoItem}>
                  <img src={flightcon} alt="Flight" />
                  <span>Pick-up Shuttle to counter and car</span>
                </div>
              </div>
            </div> */}
          </div>
          <div className={style.resultCard__reverse}>
            <div className={style.resultCard__price}>
              <span>Total</span>
              <b>
                {data.totalCost.currencyCode} {data.totalCost.amount}
              </b>
            </div>
            <Button label="Book" onClick={goToCheckout} />
          </div>
        </div>
      </aside>
    </div>
  )
}
export default ResultCard
